import { render, staticRenderFns } from "./psd.vue?vue&type=template&id=0b681c1f&scoped=true&"
import script from "./psd.vue?vue&type=script&lang=js&"
export * from "./psd.vue?vue&type=script&lang=js&"
import style0 from "./psd.vue?vue&type=style&index=0&id=0b681c1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b681c1f",
  null
  
)

export default component.exports